/* PERROWALL — déclencheurs contextuels de Léa.
 * Ouvre le widget (window.PerrowallChat / event pw:lea-open) avec un message proactif
 * sur des moments précis. 1 nudge / session, jamais en même temps que la pop-up de
 * capture ni si Léa est déjà ouverte. Matrice événement → message → objectif.
 */
(function () {
  'use strict';
  var KEY = 'pw_lea_nudged';

  function nudged() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function mark() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function modalOpen() { var m = document.getElementById('pw-capture-modal'); return !!(m && m.classList.contains('pwcm--open')); }
  function leaOpen() { try { return !!(window.PerrowallChat && window.PerrowallChat.isOpen && window.PerrowallChat.isOpen()); } catch (e) { return false; } }

  function fire(nudge) {
    if (nudged() || modalOpen() || leaOpen()) { return; }
    mark();
    document.dispatchEvent(new CustomEvent('pw:lea-open', { detail: { nudge: nudge } }));
  }

  function template() {
    var m = document.querySelector('main[data-template]');
    if (m && m.getAttribute('data-template')) { return m.getAttribute('data-template'); }
    var cls = (document.body.className.match(/template-([\w-]+)/) || [])[1];
    return cls || '';
  }

  function onReady() {
    var t = template();

    // PDP — hésitation : 28 s sur la fiche sans ajout au panier → lever l'objection « bon modèle »
    if (t.indexOf('product') === 0) {
      var engaged = false;
      document.addEventListener('cart:update', function () { engaged = true; }, { once: true });
      setTimeout(function () {
        if (!engaged) { fire("Tu hésites sur le bon modèle pour ton terrain ? Dis-moi la surface, je t'oriente en 30 secondes."); }
      }, 28000);

    // Panier — retour : rassurer juste avant de finaliser
    } else if (t.indexOf('cart') === 0) {
      setTimeout(function () {
        fire("Une question avant de finaliser ta commande ? Le SAV français est là, je peux t'aider tout de suite.");
      }, 6000);

    // Collection / liste — dwell 40 s : aide au choix
    } else if (t.indexOf('collection') === 0 || t.indexOf('list-collections') === 0) {
      setTimeout(function () {
        fire("Pas sûr du produit adapté à ton chien et à ton terrain ? Je t'aide à choisir en quelques questions.");
      }, 40000);
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', onReady); }
  else { onReady(); }
})();
